import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import { getDimensionFullName } from '../constants';

// "Influencia y Personas"
const InfluenciaYPersonas = () => (
  <>
    <p className='justified'>
      Las personas con afinidad con esta área se destacan por su afición a las
      interacciones sociales y las actividades que involucran relacionarse con
      grupos de personas. Poseen habilidades notables para la organización y
      para el trabajo en equipo. Son naturalmente sociables y amigables,
      disfrutando del ambiente colectivo y de la camaradería.
    </p>
    <p className='justified'>
      Su talento radica en la capacidad de persuasión, demostrando habilidad
      para convencer a otros sobre el valor y relevancia de distintas
      iniciativas, proyectos o propuestas. Este interés se traduce en el deseo
      de colaborar con otros, ya sea vendiendo, asistiendo a otros, entregando
      información o gestionando servicios.
    </p>
    <p className='justified'>
      Por lo tanto, podría encontrar satisfacción en roles como dirección de
      servicios sociales, dirección de personal, dirección de publicidad,
      ventas, agente de viajes o preparación física, entre otros. En estos
      roles, pueden aprovechar al máximo su tendencia natural a conectarse con
      los demás ya trabajar en entornos colaborativos.
    </p>
  </>
);

// "Fabricación y Mecánica"
const FabricacionYMecanica = () => (
  <>
    <p className='justified'>
      Las personas enfocadas en esta área muestran gran inclinación hacia los
      detalles concretos y los objetos físicos. Sienten una profunda fascinación
      por los elementos que pueden manipularse directamente y demuestran una
      habilidad excepcional en el manejo de diversas herramientas. Manifiestan
      un interés pronunciado por la tecnología y son especialmente competentes
      en su uso para el desarrollo eficiente de sus responsabilidades y
      proyectos.
    </p>
    <p className='justified'>
      La física suele ser una disciplina que entienden y dominan con facilidad,
      y las actividades de construcción, invención y generación de soluciones
      novedosas despierta su interés. Además, estas personas se sienten
      naturalmente atraídas por experiencias en que puedan entender, diseñar,
      instalar y mantener maquinaria de todo tipo. Por lo tanto, encuentran un
      gran estímulo y satisfacción en las tareas que les permiten desplegar
      estas habilidades y conocimientos, lo que incluye, pero no se limita, a
      actividades tales como mecánica automotriz, mecánica de aeronaves, o
      ingeniería química.
    </p>
  </>
);

// "Liderazgo y Management"
const LiderazgoYManagement = () => (
  <>
    <p className='justified'>
      Este perfil se asocia a personas prácticas, organizadas y con una
      habilidad innata para liderar. Poseen la capacidad de motivar y movilizar
      a su equipo en el logro de tareas, metas y objetivos específicos. Sienten
      mucha satisfacción cuando pueden observar los resultados concretos que sus
      acciones, o las de sus colaboradores, lograron alcanzar.
    </p>
    <p className='justified'>
      Además, se interesan profundamente por la administración y la
      planificación de las actividades centrales de un negocio u organización.
      Sienten una inclinación natural hacia roles que les permitan ejercer estas
      competencias, como el de gerente de un hotel, gerente de ventas, gerente
      de oficina o agente de ventas.
    </p>
    <p className='justified'>
      De este modo, pueden desplegar sus dotes de liderazgo y capacidad
      organizativa para coordinar equipos, gestionar proyectos y, en última
      instancia, conducir a una organización hacia el éxito.
    </p>
  </>
);

// "Ciencias y Naturaleza"
const CienciaYNaturaleza = () => (
  <>
    <p className='justified'>
      Las personas que se identifican con este perfil buscan explicar el mundo a
      través de principios o reglas generales, y muestran una inclinación por
      reunir evidencias que respalden su comprensión sobre diversos temas. Una
      alta orientación en esta escala da cuenta de un profundo interés tanto por
      la naturaleza como por las ciencias que explican los fenómenos naturales.
    </p>
    <p className='justified'>
      Estas personas tienden a participar en actividades como charlas, ferias
      científicas y cursos relacionados con sus intereses, evidenciando su
      pasión por lograr un entendimiento del mundo basado en el conocimiento
      científico. Se pueden interesar por aplicar sus conocimientos de las
      ciencias naturales al estudio de plantas y animales, y disfrutan de
      trabajar y estar al aire libre.
    </p>
    <p className='justified'>
      Por lo tanto, podrían encontrar y satisfacción en roles como ingeniería en
      medioambiente, guardabosque, medicina veterinaria, oceanografía, entre
      otros. Estos roles les permitirían poner en práctica su curiosidad
      científica, su amor por la naturaleza y su deseo de contribuir al
      entendimiento y necesidades del mundo natural.
    </p>
  </>
);
// "Administración y Proyectos"
const AdministracionYProyectos = () => (
  <>
    <p className='justified'>
      Las personas con este perfil se caracterizan por ser meticulosas, precisas
      y orientadas a los detalles, y suelen destacar en el desarrollo de
      proyectos emprendedores. Normalmente son personas realistas y prácticas,
      lo que les dota de una notable capacidad de perseverancia cuando se
      enfrentan a desafíos. Prefieren un mundo ordenado, lógico y estructurado,
      y suelen tener una inclinación natural a buscar la solución de problemas
      de la vida real.
    </p>
    <p className='justified'>
      Son curiosos por naturaleza y tienen un interés particular en los
      detalles. Se podrían interesar en actividades de oficina relacionadas con
      los negocios, por ejemplo en áreas como la contabilidad, la evaluación, la
      estimación, la asesoría y el desarrollo de presupuestos.
    </p>
    <p className='justified'>
      Por tanto, podrían sentirse a gusto y desempeñarse en roles como analista
      financiero o en contabilidad. En estos roles, pueden utilizar su interés y
      habilidades en el análisis detallado, la solución de problemas y la
      planificación para contribuir de manera significativa a la gestión
      eficiente de las comerciales y financieras.
    </p>
  </>
);

// "Artes y Literatura"
const ArtesYLiteratura = () => (
  <>
    <p className='justified'>
      Este perfil está compuesto por personas con habilidades e intereses
      orientados hacia las artes y ocupaciones que fomentan el pensamiento
      divergente, la originalidad y la creatividad. A menudo interpretan el
      mundo a través de principios estéticos y se sienten atraídos por lo
      distinto y novedoso.
    </p>
    <p className='justified'>
      La pasión que les caracteriza a menudo conduce a un cierto grado de
      inconformismo y una tendencia a ser críticos con la realidad o con lo
      tradicional. Suelen sentir predilección por la literatura, la música, las
      artes plásticas, el cine y cualquier forma de expresión que les permita
      canalizar su espíritu inquieto, aunque no tengan habilidades artísticas
      particulares.
    </p>
    <p className='justified'>
      Por lo tanto, pueden encontrar satisfacción y éxito en actividades
      centradas en las artes visuales, escénicas y literarias, que fomentan la
      expresión creativa y emocional. Esto incluye roles relacionados con la
      música, así como el mundo de la actuación, escultura, composición, teatro,
      entre otros, que les permitan explorar y dar forma a su única visión del
      mundo.
    </p>
  </>
);

// "Soporte Social y Educación"
const SoporteSocialYEducacion = () => (
  <>
    <p className='justified'>
      Personas con este perfil se caracterizan por una aguda sensibilidad hacia
      los problemas sociales y humanos, y poseen habilidades naturales para la
      interacción y relación con otros. Tienen la capacidad de escuchar y ayudar
      a los demás con facilidad y empatía.
    </p>
    <p className='justified'>
      Son personas que se destacan por su madurez y reflexión sobre cuestiones
      profundas, frecuentemente se cuestionan sobre el propósito de la
      existencia humana o buscan entender el significado detrás de las conductas
      de las personas con las que interactúan. Esta orientación les lleva a ser
      observadores perspicaces de las situaciones que afectan a las personas
      pudiendo empatizar con facilidad, comprendiendo los puntos de vista de los
      demás.
    </p>
    <p className='justified'>
      Este interés por ayudar a otras personas de diversas maneras se traduce en
      su gusto por enseñar, proporcionar apoyo, asesorar y orientar. Pueden
      encontrar satisfacción y éxito en roles dentro de la fonoaudiología,
      trabajo social, terapia familiar, orientación vocacional, psicología
      educativa, educación de párvulos, entre otros, donde pueden hacer un uso
      significativo de su empatía y su deseo de ayudar a los demás.
    </p>
  </>
);

// "Ciencia de Datos"
const CienciaYDatos = () => (
  <>
    <p className='justified'>
      Las personas con este perfil se caracterizan por mostrar un profundo
      interés en los procesos y las estrategias empleadas para alcanzar
      distintos objetivos. Son personas que tienden al orden y el perfeccionismo
      y utilizan una aguda lógica para abordar y resolver problemas.
    </p>
    <p className='justified'>
      Su foco se centra en los datos concretos, tangibles y prácticos, los
      cuales utilizan para el logro de metas específicas. Habitualmente
      desarrollan procedimientos y rutinas detalladas para la ejecución de sus
      objetivos y proyectos.
    </p>
    <p className='justified'>
      El interés en el manejo detallado y cuidadoso de la información es una de
      sus principales características. También se sienten atraídos por la
      utilización de las matemáticas y sistemas para el análisis e
      interpretación de datos, así como para la resolución de problemas
      técnicos. Este perfil es típicamente exitoso en roles dentro de la
      programación, ingeniería computacional e ingeniería eléctrica, donde
      pueden poner en práctica sus habilidades analíticas y de resolución de
      problemas.
    </p>
  </>
);

// const CN = 'Ciencias y Naturaleza';
// const FM = 'Fabricación y Mecánica';
// const CD = 'Ciencia de Datos';
// const AP = 'Administración y Proyectos';
// const AL = 'Artes y Literatura';
// const SE = 'Soporte Social y Educación';
// const IP = 'Influencia y Personas';
// const LM = 'Liderazgo y Management';

const VocationOneAreasDescriptionPage = ({
  user,
  background,
  number,
  isContinuation
}) => {
  const { TOP_DIM_1, TOP_DIM_2, TOP_DIM_3, TOP_DIM_4 } = user;
  // console.log({ TOP_DIM_1, TOP_DIM_2 });
  const firstDimName = getDimensionFullName(TOP_DIM_1);
  const secondDimName = getDimensionFullName(TOP_DIM_2);
  const thirdDimName = getDimensionFullName(TOP_DIM_3);
  const fourthDimName = getDimensionFullName(TOP_DIM_4);
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          {!isContinuation ? (
            <>
              {' '}
              <h2>{`2.1.1. ${firstDimName}`}</h2>
              {TOP_DIM_1 === 'IP' && <InfluenciaYPersonas />}
              {TOP_DIM_1 === 'FM' && <FabricacionYMecanica />}
              {TOP_DIM_1 === 'LM' && <LiderazgoYManagement />}
              {TOP_DIM_1 === 'CN' && <CienciaYNaturaleza />}
              {TOP_DIM_1 === 'AP' && <AdministracionYProyectos />}
              {TOP_DIM_1 === 'AL' && <ArtesYLiteratura />}
              {TOP_DIM_1 === 'SE' && <SoporteSocialYEducacion />}
              {TOP_DIM_1 === 'CD' && <CienciaYDatos />}
              <h2>{`2.1.2. ${secondDimName}`}</h2>
              {TOP_DIM_2 === 'IP' && <InfluenciaYPersonas />}
              {TOP_DIM_2 === 'FM' && <FabricacionYMecanica />}
              {TOP_DIM_2 === 'LM' && <LiderazgoYManagement />}
              {TOP_DIM_2 === 'CN' && <CienciaYNaturaleza />}
              {TOP_DIM_2 === 'AP' && <AdministracionYProyectos />}
              {TOP_DIM_2 === 'AL' && <ArtesYLiteratura />}
              {TOP_DIM_2 === 'SE' && <SoporteSocialYEducacion />}
              {TOP_DIM_2 === 'CD' && <CienciaYDatos />}
            </>
          ) : (
            <>
              {TOP_DIM_3 && (
                <>
                  <h2>{`2.1.3. ${thirdDimName}`}</h2>
                  {TOP_DIM_3 === 'IP' && <InfluenciaYPersonas />}
                  {TOP_DIM_3 === 'FM' && <FabricacionYMecanica />}
                  {TOP_DIM_3 === 'LM' && <LiderazgoYManagement />}
                  {TOP_DIM_3 === 'CN' && <CienciaYNaturaleza />}
                  {TOP_DIM_3 === 'AP' && <AdministracionYProyectos />}
                  {TOP_DIM_3 === 'AL' && <ArtesYLiteratura />}
                  {TOP_DIM_3 === 'SE' && <SoporteSocialYEducacion />}
                  {TOP_DIM_3 === 'CD' && <CienciaYDatos />}
                </>
              )}
              {TOP_DIM_4 && (
                <>
                  <h2>{`2.1.4. ${fourthDimName}`}</h2>
                  {TOP_DIM_4 === 'IP' && <InfluenciaYPersonas />}
                  {TOP_DIM_4 === 'FM' && <FabricacionYMecanica />}
                  {TOP_DIM_4 === 'LM' && <LiderazgoYManagement />}
                  {TOP_DIM_4 === 'CN' && <CienciaYNaturaleza />}
                  {TOP_DIM_4 === 'AP' && <AdministracionYProyectos />}
                  {TOP_DIM_4 === 'AL' && <ArtesYLiteratura />}
                  {TOP_DIM_4 === 'SE' && <SoporteSocialYEducacion />}
                  {TOP_DIM_4 === 'CD' && <CienciaYDatos />}
                </>
              )}
            </>
          )}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOneAreasDescriptionPage;
